import React, { useState } from "react";
import { IonAlert, IonFab, IonFabButton, IonFabList, IonIcon, isPlatform } from "@ionic/react";
import { cubeOutline, location, menuOutline } from "ionicons/icons";
import { AppLauncher } from "@capacitor/app-launcher";
import "./PermitBoundariesTab.css";
import { Area } from "../models/Area";

interface PermitBoundariesProps {
    areas?: Area[];
}

const MenuOnMap: React.FC<PermitBoundariesProps> = ({ areas }) => {
    const [displayCoordinates, setDisplayCoordinates] = useState(false);

    const runOnDevice = isPlatform("hybrid");

    const handleArButtonClick = async () => {
        var url = isPlatform("ios") ? "meemimvgis://deeplinks?" : "com.meemim.vgis";
        // const { value } = await AppLauncher.canOpenUrl({ url });

        //if (value) {
        await AppLauncher.openUrl({ url });
        //}
    };

    const formatAreas = () => {
        const formattedAreas = areas
            ?.map((b, i) =>
                b.polygon.coordinates
                    .map((ring, j) => {
                        const header = `Boundary ${i + 1} (${ring.length} points):`;
                        const pts = ring.map(([x, y]) => `• (${x},\n   ${y})`).join("\n");
                        return `${header}\n${pts}`;
                    })
                    .join("\n\n")
            )
            .join("\n\n");
        return `<pre>${formattedAreas}</pre>`;
    };

    return (
        <>
            <IonFab horizontal="end" vertical="bottom" style={{ marginBottom: 70 }}>
                <IonFabButton>
                    <IonIcon icon={menuOutline} />
                </IonFabButton>
                <IonFabList side="top">
                    {runOnDevice && (
                        <IonFabButton onClick={handleArButtonClick}>
                            <IonIcon icon={cubeOutline}></IonIcon>
                        </IonFabButton>
                    )}
                    <IonFabButton onClick={() => setDisplayCoordinates(true)}>
                        <IonIcon icon={location}></IonIcon>
                    </IonFabButton>
                </IonFabList>
            </IonFab>

            <IonAlert
                isOpen={displayCoordinates}
                onDidDismiss={() => setDisplayCoordinates(false)}
                header="Coordinates"
                message={areas ? formatAreas() : "No coordinates available"}
                buttons={["OK"]}
                cssClass="coords-alert"
            />
        </>
    );
};

export default MenuOnMap;
